export interface IAuthUser {
  theme: string | null
  token: string | null
  roles: Roles
  rolSelected: RolSelected[]
  isSelectDevelop: boolean
  lastRoleUpdate: null | string
  binaryRoles: number
}

export type ErrorPortals = any

export interface RolSelected {
  id: number
  isChecked: boolean
  rol: string
  name: string
  text: string
}
export interface Roles {
  ADVANCED: string
  STARTER: string
  BASIC: string
  BROKER: string
  AGENCY_BROKER: string
  AGENCY: string
  PRIME: string
  PRO: string
  DEVELOPER: string
  ROLE_ADMIN_DEVELOPER: string
  DEVELOPER_USER: string
  ASSOCIATION: string
}
export enum EnumRole {
  ADVANCED = 'ADVANCED',
  STARTER = 'STARTER',
  BASIC = 'BASIC',
  BROKER = 'BROKER',
  AGENCY_BROKER = 'AGENCY_BROKER',
  AGENCY = 'AGENCY',
  PRIME = 'PRIME',
  PRO = 'PRO',
  DEVELOPER = 'DEVELOPER',
  ROLE_ADMIN_DEVELOPER = 'ROLE_ADMIN_DEVELOPER',
  DEVELOPER_USER = 'DEVELOPER_USER',
  ASSOCIATION = 'ASSOCIATION'
}

export enum EPlanType {
  STARTER = 'STARTER',
  ADVANCED = 'ADVANCED',
  TRIAL = 'TRIAL_ADVANCED'
}

export interface IProfileUser {
  agencyId: number
  agencyName?: string
  createdAt: string
  agencyUsersWithPrime: boolean
  isMacrobolsa: boolean
  domain: null | string
  domainCertificateStatus: string
  email: string
  fullname: string
  fullPlanUsed: boolean
  fullPrime: boolean
  fullPrimeUsed: boolean
  hasCampaignUsers: boolean
  isCampaignUser: boolean
  isLoading: boolean
  noShowRequirementOnBoarding: boolean
  notificationsReminder: boolean
  oldRoles: any
  isOldPro: boolean
  phoneNumber: string
  phoneNumberVerified: boolean
  photo: string
  planAvailableUntil: string
  planType: EPlanType
  primeAvailableUntil: any
  primeType: null | string
  profileId: string
  specialPermission: any[]
  subdomain: string
  termsAndConditions: string | null
  trialUsed: boolean
  userFullname: string
  userId: number
  userPaymentStatus: string
  userPhoneNumber: string
  userPhoto: string
  userScoresSectionConfig: string
  verified: boolean
}

export interface IPublicUserProfile {
  name: string
  email?: string
  phoneNumber: string
  photo?: string
  agencyName?: string
}

export interface IPassMinimumFields {
  fullname: string
  email: string
  phoneNumber: string
  birthday: string
  gender: string
  currentPosition: string
  agencyName: string
  agencyPhone: string
  taxId: string
  state: string
  city: string
  postalCode: string
  birthdayYear: string
  birthdayMonth: string
  birthdayDay: string
  profileCompleted: boolean
  isCampaignUser: boolean
  hasCampaignUsers: boolean
}

export interface IUserResponse {
  agencyCardReference: null
  agencyId: number
  agencyName: string
  agencyPaymentStatus: string
  agencyUsersWithPrime: boolean
  createdAt: string
  domain: null
  domainCertificateStatus: string
  email: string
  fullname: string
  fullPlanUsed: boolean
  fullPrimeUsed: boolean
  isOldPro: boolean
  notificationsReminder: boolean
  oldRoles: boolean
  persist: IPersist[]
  phoneNumber: string
  phoneNumberVerified: boolean
  photo: string
  planAvailableUntil: string
  planType: EPlanType
  primeAvailableUntil: string
  primeType: string
  profileId: string
  specialPermission: ISpecialPermission[]
  subdomain: string
  termsAndConditions: string
  termsAndConditionsWiggot: string
  test: boolean
  trialPrimeUsed: boolean
  trialUsed: boolean
  userCardReference: null
  userId: number
  userPaymentStatus: string
  userScoresSectionConfig: string
  verified: boolean
}

export interface IPersist {
  key: string
  value: string
}

export interface ISpecialPermission {
  search: ISearch
  contacts: IContacts
  map: IMap
}

export interface IContacts {
  viewInfo: boolean
  include: string
}

export interface IMap {
  view: boolean
}

export interface ISearch {
  comissionMin: number
  filterExclusion: string
  logoAssociationsAgency: boolean
}

export interface IUserData {
  id: number
  profileId: string
  email: string
  authId: null | string
  roles: number
  score: null | number
  fullName: string
  firstName: string
  lastName: string
  birthday: Date
  gender: string
  currentPosition: string
  state: string
  city: string
  postalCode: string
  taxId: string
  phoneNumber: string
  phoneNumberVerified: number
  photo: string
  backgroundImage: string
  agencyName: null | string
  agencyPhone: null | string
  agencyAddress: null | string
  agencyLogo: null | string
  yearsInIndustry: number
  rolCompany: string
  typeOfProperties: string
  housingLevel: string
  completed: number
  verified: number
  certified: number
  blocked: number
  test: number
  agencyId: number
  associationId: null | number
  createdAt: Date
  verifiedAt: Date
  certifiedAt: null | Date
  blockedAt: null | Date
  agencyJoinedAt: Date
  associationJoinedAt: null | Date
  loggedOutAt: Date
  loggedInAt: Date
  modifiedAt: Date
  showAgencyPropertiesInProfile: number
  userScoresSectionConfig: string
  paymentGatewayId: string
  stripeExternalId: null | string
  phoneNumberVerifiedAt: Date
  fromApplication: number
  modifiedByApplicationAt: null | Date
  termsAndConditions: string
  termsAcceptedAt: Date
  housingLevelOther: null | string
  deviceToken: string
  deviceType: string
  createdFrom: string
  createdFromDomain: null | string
  choseToBeAnAgency: number
  deletedAt: null | Date
  ratio: string
}
